import {ProcessDatePicker} from "components";

import {useFormContext, Controller} from "react-hook-form";
import useValidateVoyages from "views/ProcessDetails/hooks/useValidateVoyages";
import {Process} from "views/ProcessDetails/refactor/types/process.types";

type Props = {
  index: number;
  disabled: boolean;
};

const VoyageETAField = (props: Props) => {
  const {index, disabled} = props;
  const {control} = useFormContext<Process>();
  const {dateIsFarFromOneYear} = useValidateVoyages();

  return (
    <Controller
      name={
        `boarding.voyages.${index}.estimatedCargoUnload` as `boarding.voyages.0.estimatedCargoUnload`
      }
      control={control}
      rules={{
        validate: {
          dateIsFarFromOneYear: (value) => {
            const dateError = dateIsFarFromOneYear(value);

            if (dateError === "future") {
              return `Data futura inválida para o ETA da viagem ${index + 1}, superior a 12 meses.`;
            }

            if (dateError === "past") {
              return `Data passada inválida para o ETA da viagem ${index + 1}, superior a 12 meses.`;
            }

            if (dateError === "invalid") {
              return `Data inválida para o ETA da viagem ${index + 1}.`;
            }

            return true;
          },
        },
      }}
      render={({field: {value}}) => (
        <ProcessDatePicker
          value={value}
          name={`boarding.voyages.${index}.estimatedCargoUnload`}
          errorName="ETA"
          title={`ETA viagem ${index + 1}`}
          disabled={disabled}
          fullWidth
          label="ETA"
        />
      )}
    />
  );
};

export default VoyageETAField;
